import * as React from 'react'

const EventHelpers = {
  stopPropagationPreventDefault: (event: React.MouseEvent<any> | React.KeyboardEvent<any>) => {
    event.stopPropagation()
    event.preventDefault()
  }
}

export { EventHelpers }